/**
 * Delivery refs (`DEL-001`, … `DEL-999`, `DEL-1000`) are padded to three
 * digits only, so past 999 their text order is wrong: `'DEL-1000'` sorts
 * before `'DEL-999'` because `'1' < '9'`. Every ref tie-break compares the
 * number instead — one collator, built once.
 */
const refCollator = new Intl.Collator('en', { numeric: true });

/** Ascending by the ref's number: DEL-999 before DEL-1000. */
export function compareDeliveryRefs(a: string, b: string): number {
  return refCollator.compare(a, b);
}
